import React, { useEffect, useState } from "react";
import { useApiContext } from "../../../Utils/ApiContext/ApiContext";
import { getDecryptedAccessToken, getDecryptedData } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Checkbox,
  Autocomplete,
  Button,
  Chip,
  Box,
} from "@mui/material";
import { useParams } from "react-router-dom";
import ApiServices from "../../../Utils/ApiServices/ApiServices";

const CreateWorkout = () => {
  const { exercises, fetchData } = useApiContext();
  const accessToken = getDecryptedAccessToken();
  const [filteredExercises, setFilteredExercises] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [selectedPrimaryMuscles, setSelectedPrimaryMuscles] = useState([]);
  const [selectedSecondaryMuscles, setSelectedSecondaryMuscles] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [primaryMuscleOptions, setPrimaryMuscleOptions] = useState([]);
  const [secondaryMuscleOptions, setSecondaryMuscleOptions] = useState([]);
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [selectedExercisesData, setSelectedExercisesData] = useState([]);

  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [exerciseDays, setExerciseDays] = useState({});
  const params= useParams()
const [planName,setPlanName]=useState("")
const [isAssigning, setIsAssigning] = useState(false);
const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
const LoginUserData = getDecryptedData()
  
  useEffect(() => {
    fetchData("/apis/default/api/exercises");
    setFilteredExercises(exercises);
    extractFilterOptions(exercises);
  }, [exercises]);

  const extractFilterOptions = (data) => {
    const primaryMusclesSet = new Set();
    const secondaryMusclesSet = new Set();
    const equipmentSet = new Set();

    data.forEach((exercise) => {
      exercise.primary_muscles
        .replace(/"/g, "")
        .split(", ")
        .forEach((muscle) => primaryMusclesSet.add(muscle));
      exercise.secondary_muscles
        .replace(/"/g, "")
        .split(", ")
        .forEach((muscle) => secondaryMusclesSet.add(muscle));
      equipmentSet.add(exercise.equipment.replace(/"/g, ""));
    });

    setPrimaryMuscleOptions(Array.from(primaryMusclesSet));
    setSecondaryMuscleOptions(Array.from(secondaryMusclesSet));
    setEquipmentOptions(Array.from(equipmentSet));
  };

  const applyFilters = (
    search,
    primaryMuscles,
    secondaryMuscles,
    equipment
  ) => {
    let filtered = exercises;

    if (search) {
      filtered = filtered.filter((ex) =>
        ex.exercise_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (primaryMuscles.length > 0) {
      filtered = filtered.filter((ex) =>
        primaryMuscles.some((muscle) => ex.primary_muscles.includes(muscle))
      );
    }

    if (secondaryMuscles.length > 0) {
      filtered = filtered.filter((ex) =>
        secondaryMuscles.some((muscle) => ex.secondary_muscles.includes(muscle))
      );
    }

    if (equipment.length > 0) {
      filtered = filtered.filter((ex) => equipment.includes(ex.equipment));
    }

    setFilteredExercises(filtered);
  };
  const handleSelectExercise = (exercise) => {
    setSelectedExercises((prev) =>
      prev.some((ex) => ex.id === exercise.id)
        ? prev.filter((ex) => ex.id !== exercise.id)
        : [...prev, exercise]
    );

    setSelectedExercisesData((prev) =>
      prev.some((ex) => ex.exercise_id === exercise.id)
        ? prev.filter((ex) => ex.exercise_id !== exercise.id)
        : [...prev, { exercise_id: exercise.id, sets: 3, repeats: 12 }]
    );
  };
  const handleExerciseChange = (exerciseId, field, value) => {
    setSelectedExercisesData((prev) =>
      prev.map((ex) =>
        ex.exercise_id === exerciseId ? { ...ex, [field]: value } : ex
      )
    );
  };
    const handleDaysChange = (exerciseId, newDays) => {
      setExerciseDays((prev) => ({ ...prev, [exerciseId]: newDays }));
    };
  
    const handleAssignExercises = async () => {
        setIsAssigning(true);
      
        try {
          // Flattened exercise list with day inside each exercise object
          const exercises = daysOfWeek.flatMap((day) =>
            selectedExercisesData
              .filter((ex) => exerciseDays[ex.exercise_id]?.includes(day))
              .map((ex) => ({
                exercise_id: ex.exercise_id,
                sets: ex.sets,
                repeats: ex.repeats,
                day: day
              }))
          );
      
          const payload = {
            plan_name: planName,
            created_by: LoginUserData.id,
            created_for_patient_id: null, // Or params.pid if needed
            visibility: "public",
            exercises
          };
      
          await ApiServices.post("/apis/default/api/workoutplans", payload, {
            Authorization: `Bearer ${accessToken}`,
          });
      
          setSnackbar({
            open: true,
            message: "Exercises assigned successfully!",
            severity: "success",
          });
      
          setSelectedExercises([]);
          setSelectedExercisesData([]);
          setExerciseDays({});
        } catch (error) {
          setSnackbar({
            open: true,
            message: "Failed to assign exercises!",
            severity: "error",
          });
        } finally {
          setIsAssigning(false);
        }
      };
      
  return (
    <div>
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <TextField
          label="Search Exercise"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            applyFilters(
              e.target.value,
              selectedPrimaryMuscles,
              selectedSecondaryMuscles,
              selectedEquipment
            );
          }}
          fullWidth
        />
        <Autocomplete
          multiple
          options={primaryMuscleOptions}
          getOptionLabel={(option) => option}
          value={selectedPrimaryMuscles}
          onChange={(e, newValue) => {
            setSelectedPrimaryMuscles(newValue);
            applyFilters(
              searchQuery,
              newValue,
              selectedSecondaryMuscles,
              selectedEquipment
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Primary Muscles"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
        />
        <Autocomplete
          multiple
          options={secondaryMuscleOptions}
          getOptionLabel={(option) => option}
          value={selectedSecondaryMuscles}
          onChange={(e, newValue) => {
            setSelectedSecondaryMuscles(newValue);
            applyFilters(
              searchQuery,
              selectedPrimaryMuscles,
              newValue,
              selectedEquipment
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Secondary Muscles"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
        />
        <Autocomplete
          multiple
          options={equipmentOptions}
          getOptionLabel={(option) => option}
          value={selectedEquipment}
          onChange={(e, newValue) => {
            setSelectedEquipment(newValue);
            applyFilters(
              searchQuery,
              selectedPrimaryMuscles,
              selectedSecondaryMuscles,
              newValue
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Equipment"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
        />
      </div>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: 250, overflowY: "auto" }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <b>Name</b>
              </TableCell>
              <TableCell>
                <b>Primary Muscles</b>
              </TableCell>
              <TableCell>
                <b>Secondary Muscles</b>
              </TableCell>
              <TableCell>
                <b>Equipment</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredExercises.map((exercise) => (
              <TableRow key={exercise.id}>
                <TableCell>
                  <Checkbox
                    checked={selectedExercises.some(
                      (ex) => ex.id === exercise.id
                    )}
                    onChange={() => handleSelectExercise(exercise)}
                  />
                </TableCell>
                <TableCell>{exercise.exercise_name}</TableCell>
                <TableCell>
                  {exercise.primary_muscles.replace(/"/g, "")}
                </TableCell>
                <TableCell>
                  {exercise.secondary_muscles.replace(/"/g, "")}
                </TableCell>
                <TableCell>{exercise.equipment.replace(/"/g, "")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

            {selectedExercises.length > 0 && (
        <div style={{ marginTop: "10px" }}>
          <h4>Selected Exercises:</h4>
          <TableContainer component={Paper} sx={{ maxHeight: 250, overflowY: "auto" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>GIF</b></TableCell>
                  <TableCell><b>Sets</b></TableCell>
                  <TableCell><b>Repeats</b></TableCell>
                  <TableCell><b>Days</b></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {selectedExercises.map((ex) => {
                    const exData = selectedExercisesData.find((e) => e.exercise_id === ex.id) || { sets: 3, repeats: 12 };
                    return (
                      <TableRow key={ex.id}>
                        <TableCell>{ex.exercise_name}</TableCell>
                        <TableCell><img src={ex.gif_url} alt={ex.exercise_name} width="50" height="50" /></TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            size="small"
                            value={exData.sets}
                            onChange={(e) => handleExerciseChange(ex.id, "sets", Number(e.target.value))}
                            inputProps={{ min: 1 }}
                            sx={{ width: 60 }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            size="small"
                            value={exData.repeats}
                            onChange={(e) => handleExerciseChange(ex.id, "repeats", Number(e.target.value))}
                            inputProps={{ min: 1 }}
                            sx={{ width: 60 }}
                          />
                        </TableCell>
                        <TableCell>
                          <Autocomplete
                            multiple
                            options={daysOfWeek}
                            value={exerciseDays[ex.id] || []}
                            onChange={(_, newValue) => handleDaysChange(ex.id, newValue)}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                              ))
                            }
                            renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder="Days" />}
                          />
                        </TableCell>
                        <TableCell>
                          <Button size="small" color="error" onClick={() => setSelectedExercises(selectedExercises.filter(e => e.id !== ex.id))}>
                            Remove
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ m: 2 }}>
      <TextField
        label="Plan Name"
        variant="outlined"
        fullWidth
        value={planName}
        onChange={(e) => setPlanName(e.target.value)}
      />
    </Box>
    
          {/* Assign Button */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleAssignExercises}
            disabled={isAssigning}
            sx={{ marginTop: "10px" }}
          >
            {isAssigning ? "Assigning..." : "Assign Exercises"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CreateWorkout;
